import React from 'react'

import UploadResource from 'assets/images/explore-learnings/upload-resource.svg'

import { Button } from '../Button'

interface UploadResourceCardProps {
  onUploadClick?: () => void
}

const UploadResourceCard: React.FC<UploadResourceCardProps> = ({ onUploadClick }) => {
  return (
    <div className="w-full rounded-2xl p-[2px] gradient-border-ltr ">
      <div className="w-full bg-white flex rounded-2xl overflow-hidden">
        <div className="bg-white flex items-center justify-center shrink-0">
          <img src={UploadResource} alt="resource illustration" className="object-cover h-full" />
        </div>

        <div className="flex items-center gap-5 py-12 pl-8 pr-11 justify-between flex-1">
          <div>
            <h3 className="font-semibold">Would you like to link any additional resource?</h3>
            <p className="text-sm mt-[6px] leading-6 text-[#505050]">Upload a resource to review.</p>
          </div>
          <Button onClick={onUploadClick} text="Upload resource" className="h-10" />
        </div>
      </div>
    </div>
  )
}

export default UploadResourceCard
